import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AlarmModalSongItem from './AlarmModalSongItem'

class AlarmModalSongList extends Component {
  componentDidMount() {
    if (!this.props.allSongs.length || this.props.selectedSongId) return

    // Pre-select first song if creating new alarm
    const initialSong = this.props.allSongs[0]
    this.props.selectSongHandler(initialSong.songId)
  }

  render() {
    return (
      <ul className="alarm_block_list offset_mod">
        {this.props.allSongs.map((song) => (
          <AlarmModalSongItem
            key={song.songId}
            {...song}
            selectSongHandler={() => this.props.selectSongHandler(song.songId)}
            selected={this.props.selectedSongId === song.songId}
          />
        ))}
      </ul>
    )
  }
}

const mapStateToProps = ({ player: { allSongs } }) => ({
  allSongs,
})

export default connect(mapStateToProps)(AlarmModalSongList)

AlarmModalSongList.propTypes = {
  selectSongHandler: PropTypes.func.isRequired,
  selectedSongId: PropTypes.string.isRequired,
}
